import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Header.css';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.header 
      className={`header ${isScrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <img src="/images/logo.png" alt="Genesys Sistemas" className="logo-image" />
          </div>
          
          <nav className="nav">
            <button onClick={() => scrollToSection('inicio')} className="nav-link">Início</button>
            <button onClick={() => scrollToSection('beneficios')} className="nav-link">Benefícios</button>
            <button onClick={() => scrollToSection('portfolio')} className="nav-link">Portfólio</button>
            <button onClick={() => scrollToSection('processo')} className="nav-link">Processo</button>
            <button onClick={() => scrollToSection('contato')} className="nav-link">Contato</button>
          </nav>

          <a href="#contato" className="btn-primary header-cta">
            Solicitar Orçamento
          </a>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;